import i18n from "i18next";

export const initialState = (config) => {
  return {
    filesUploaded: {},
    status: "draft",
    everPublished: false,
    // === Task 24 — non-undoable Flow Viewer overlay flag ===
    flowViewerOpen: false,
    // === Task 37 — non-undoable workflow suggestions slice ===
    workflowSuggestions: {
      loading: false,
      error: null,
      suggestions: null,
      scope: null,
      generatedAt: null,
    },
    // === /Task 37 ===
    // === Interactivity Studio #4 Task 1 — non-undoable unified Studio slice ===
    interactivityStudio: { open: false, tab: null, busy: null },
    // === /Interactivity Studio Task 1 ===
    undoGroup: {
      past: [],
      present: {
        globalConfig: {
          title: undefined,
          canvasRatio: config.defaultAspectRatio || 16 / 9,
          minTimeProgress: 0,
          visorNav: {
            player: true,
            sidebar: true,
            keyBindings: true,
            timeBar: true,
            // Task 9 (visor-ui): disables the landscape two-layer auto-hide
            // (chromeState.js autoHideNext) when true — chrome stays visible.
            alwaysShowControls: false,
          },
          trackProgress: true,
          age: {
            min: 0,
            max: 0,
          },
          context: undefined,
          rights: "public",
          keywords: [],
          typicalLearningTime: {
            h: 0,
            m: 0,
            s: 0,
          },
          author: window.idealStudio_editor_params && window.idealStudio_editor_params.name,
          version: "1.0.0",
          thumbnail: "",
          structure: "linear",
          difficulty: undefined,
          allowClone: true,
          allowDownload: true,
          allowComments: true,
          jobWidgetVisible: true,
          chatbotOptIn: false,
          subtitlesOnByDefault: false,
        },
        indexSelected: "pa-1497983247795",
        boxesById: {},
        boxSelected: -1,
        boxLevelSelected: 0,
        marksById: {},
        navItemsIds: ["pa-1497983247795"],
        navItemSelected: "pa-1497983247795",
        navItemsById: {
          0: {
            id: 0,
            children: ["pa-1497983247795"],
            boxes: [],
            level: 0,
            type: "",
            hidden: false,
          },
          "pa-1497983247795": {
            id: "pa-1497983247795",
            isExpanded: true,
            parent: 0,
            linkedBoxes: {},
            children: [],
            boxes: [],
            level: 1,
            type: "slide",
            hidden: false,
            extraFiles: {},
            customSize: 0,
          },
        },
        containedViewsById: {},
        containedViewSelected: 0,
        displayMode: "list",
        pluginToolbarsById: {},
        viewToolbarsById: {
          "pa-1497983247795": {
            id: "pa-1497983247795",
            viewName: i18n.t("slide"),
            breadcrumb: "hidden",
            courseTitle: "hidden",
            documentSubtitle: "hidden",
            documentSubtitleContent: i18n.t("subtitle"),
            documentTitle: "expanded",
            documentTitleContent: "",
            numPage: "hidden",
            numPageContent: "",
            background: "#ffffff",
            backgroundAttr: "",
            aspectRatio: "",
            autoNext: false,
            autoNextShowCta: false,
            sceneEndCta: false,
            minTime: 3,
            mandatoryType: "waitForTime",
            isMandatory: true,
            audio_preview_enable: false,
          },
        },
        isBusy: "",
        exercises: {
          "pa-1497983247795": {
            id: "pa-1497983247795",
            submitButton: true,
            trackProgress: false,
            attempted: false,
            weight: 10,
            minForPass: 50,
            exercises: {},
            score: 0,
            attemptedCount: 0,
            correctAnswered: false,
          },
        },
        uploadedTemplates: {},
      },
      future: [],
    },
  };
};

/**
 * Build a minimal "empty training" state for the New Training flow.
 *
 * Produces one root nav item (id=0) plus exactly one empty scene, no boxes,
 * and a globalConfig built from `reducers/global_config` `emptyState` merged
 * with caller-supplied overrides. Shapes match what existing reducers
 * (`navItemCreator`, `toolbarElementCreator`) build, so the resulting state
 * can be hydrated cleanly by the editor without crashing.
 *
 * @param {object} [globalConfigOverrides] - fields to merge over the default emptyState globalConfig.
 * @returns {object} a state slice suitable for `_saveAs` payloads.
 */
export function createEmptyTrainingState(globalConfigOverrides = {}) {
  // Lazy require avoids the import cycle:
  // state.es6 -> global_config -> common/actions -> core/editor/main -> state.es6
  const { emptyState: globalConfigEmptyState } = require("../../reducers/global_config");
  const globalConfig = { ...globalConfigEmptyState, ...globalConfigOverrides };

  // Brand-new training payload sent to _saveAs is intentionally
  // structure-empty: only the synthetic root nav item, no scenes, no boxes.
  // The first real scene is added on the editor side via dispatch(addNavItem(...))
  // right after the new training rehydrates, so the navItem matches whatever
  // shape the live ADD_NAV_ITEM reducer produces (no drift between manual
  // factory output and reducer output).
  const ROOT_ID = 0;
  const navItemsById = {
    [ROOT_ID]: {
      id: ROOT_ID,
      children: [],
      boxes: [],
      level: 0,
      type: "",
      hidden: false,
    },
  };

  return {
    globalConfig,
    navItemsById,
    navItemsIds: [],
    indexSelected: 0,
    navItemSelected: 0,
    boxesById: {},
    boxSelected: -1,
    boxSelectedAll: [],
    boxLevelSelected: 0,
    marksById: {},
    pluginToolbarsById: {},
    viewToolbarsById: {},
    containedViewsById: {},
    containedViewSelected: 0,
    displayMode: "list",
    isBusy: "",
    exercises: {},
    uploadedTemplates: {},
    filesUploaded: {},
    status: "draft",
    everPublished: false,
  };
}
